import moment from 'moment';
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { KTIcon, toAbsoluteUrl } from '../../_metronic/helpers';
import { useTranslation } from "react-i18next";
import { formatDateWithDateAndMonthName, formatDateWithTZ, FormatInvoiceDecimalNumber, getValueFromResource, toUtcDate } from '../../common/timeLiveFunction';
/* import { formatDateWithDateAndMonthName } from '../../common/timesheetFunction'; */

const TimesheetNavBar = () => {
    const { timesheetStatus, totalHours, submittedDate, decimalFormat, nonBillableHours, todayHours, billableHours } = useAppSelector((state) => state.timesheet);
    const { cultureInfoName, decimalPlaces,ProfileTimeZoneIANA } = useAppSelector((state) => state.globalState);
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    
    return (
        <>
            <div className="row col-md-12 col-sm-12 col-xs-12 navBarParentDiv">
                <div className='col-md-2 col-sm-2 col-xs-12' style={{ paddingLeft: 0 }}>
                    <div className='cardInfoShadow'>
                        <div className='tsNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-WorkToday.svg')}
                                    />
                                </div>
                            </div>
                            <div className='tsNavBarInnerBoxSecondSection'>
                                <span className="fw-bold d-block fs-3 tsNavBarInfoText">{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),  Number(todayHours), 2) : todayHours}</span>
                                {/* <a className="text-uppercase tsNavBarInfoLabel">{t('Worked Today')}</a> */}
                                <a className="text-uppercase tsNavBarInfoLabel">{getValueFromResource('Worked Today', dispatch, t)}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-2 col-sm-2 col-xs-12'>
                    <div className='cardInfoShadow'>
                        <div className='tsNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-TotalHours.svg')}
                                    />
                                </div>
                            </div>
                            <div className='tsNavBarInnerBoxSecondSection'>
                                <span className="fw-bold d-block fs-3 tsNavBarInfoText">{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),  Number(totalHours), 2) : totalHours}</span>
                                {/* <a className="text-uppercase tsNavBarInfoLabel">{t('Total Hours')}</a> */}
                                <a className="text-uppercase tsNavBarInfoLabel">{getValueFromResource('Total Hours', dispatch, t)}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-2 col-sm-2 col-xs-12'>
                    <div className='cardInfoShadow'>
                        <div className='tsNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-Billable.svg')}
                                    />
                                </div>
                            </div>
                            <div className='tsNavBarInnerBoxSecondSection'>
                                <span className="fw-bold d-block fs-3 tsNavBarInfoText">{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),  Number(billableHours), 2) : billableHours}</span>
                                {/* <a className="text-uppercase tsNavBarInfoLabel">{t('Billable Hours')}</a> */}
                                <a className="text-uppercase tsNavBarInfoLabel">{getValueFromResource('Billable Hours', dispatch, t)}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-2 col-sm-2 col-xs-12'>
                    <div className='cardInfoShadow'>
                        <div className='tsNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-NonBillable.svg')}
                                    />
                                </div>
                            </div>
                            <div className='tsNavBarInnerBoxSecondSection'>
                                <span className="fw-bold d-block fs-3 tsNavBarInfoText">{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),  Number(nonBillableHours), 2): nonBillableHours}</span>
                                {/* <a className="text-uppercase tsNavBarInfoLabel">{t('Non-Billable Hours')}</a> */}
                                <a className="text-uppercase tsNavBarInfoLabel">{getValueFromResource('Non-Billable Hours', dispatch, t)}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-2 col-sm-2 col-xs-12'>
                    <div className='cardInfoShadow'>
                        <div className='tsNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    {timesheetStatus.text == 'Approved' ?
                                        <span className="symbol-label bg-light-info">
                                            <i className="ki-outline ki-notification-status text-info fs-1"></i>
                                        </span> :
                                        <img
                                            src={toAbsoluteUrl('/media/svg/customSVG/icon-Status.svg')}
                                        />
                                    }
                                </div>
                            </div>
                            <div className='tsNavBarInnerBoxSecondSection'>
                                <span className="fw-bold d-block" style={{ color: '#172b4d', marginBottom: -2.6, marginTop: 5, fontSize: '1.14rem' }}>{timesheetStatus.text}</span>
                                {/* <a className="text-uppercase tsNavBarInfoLabel">{t('Timesheet Status')}</a> */}
                                <a className="text-uppercase tsNavBarInfoLabel">{getValueFromResource('Timesheet Status', dispatch, t)}</a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className='col-md-2 col-sm-2 col-xs-12' style={{ paddingRight: 0 }}>
                    <div className='cardInfoShadow'>
                        <div className='tsNavBarInnerBoxParent'>
                            <div className='tsNavBarInnerBoxFirstSection'>
                                <div className='tsNavBarInnerBoxFirstInner' />
                                <div className='symbol symbol-48px me-3'>
                                    <img
                                        src={toAbsoluteUrl('/media/svg/customSVG/icon-SubmitDate.svg')}
                                        alt='Worked Today'
                                    />
                                </div>
                            </div>
                            <div className='tsNavBarInnerBoxSecondSection'>
                                {/* <span className="fw-bold d-block fs-4 tsNavBarInfoText">{submittedDate != null ? moment(submittedDate).format('DD MMM YYYY') : '-'}</span> */}
                                <span className="fw-bold d-block fs-4 tsNavBarInfoText">{submittedDate != null ? formatDateWithTZ(submittedDate, cultureInfoName.toString(), ProfileTimeZoneIANA) : '-'}</span>
                                {/* <a className="text-uppercase tsNavBarInfoLabel">{t('submitted Date')}</a> */}
                                <a className="text-uppercase tsNavBarInfoLabel">{getValueFromResource('submitted Date', dispatch, t)}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default TimesheetNavBar